/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import MedicationOrdersidaddMedicationsMedicationOrder from './MedicationOrdersidaddMedicationsMedicationOrder';

/**
 * The IdAddMedicationsBody model module.
 * @module model/IdAddMedicationsBody
 * @version v0.3
 */
export default class IdAddMedicationsBody {
  /**
   * Constructs a new <code>IdAddMedicationsBody</code>.
   * @alias module:model/IdAddMedicationsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IdAddMedicationsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IdAddMedicationsBody} obj Optional instance to populate.
   * @return {module:model/IdAddMedicationsBody} The populated <code>IdAddMedicationsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IdAddMedicationsBody();
      if (data.hasOwnProperty('medication_order'))
        obj.medicationOrder = MedicationOrdersidaddMedicationsMedicationOrder.constructFromObject(data['medication_order']);
    }
    return obj;
  }
}

/**
 * @member {module:model/MedicationOrdersidaddMedicationsMedicationOrder} medicationOrder
 */
IdAddMedicationsBody.prototype.medicationOrder = undefined;

